export enum ONBOARDING_STEP_QUERY_PARAM {
  TENANT = 'tenant',
  INVITE_MEMBERS = 'inviteMembers',
  CHOOSE_PLAN = 'choosePlan',
  PAYMENTS = 'payments',
  COMPLETE = 'complete',
}

export const KEYS = {
  STORAGE_ONBOARDING_FORM_DATA: 'STORAGE_ONBOARDING_FORM_DATA',
};
